import React, { FC } from 'react';
import { numberFormat, Skeleton } from '@mofid-securities/uikit';
import FormUnderlinedText, {
  IFormUnderlinedTextProps,
} from '@/components/UnderlinedText/FormUnderlinedText';

export interface IFormUnderlinedAmountProps
  extends Omit<IFormUnderlinedTextProps, 'value'> {
  amount: number | undefined;
  className?: string;
  isLoading?: boolean;
}

const FormUnderlinedAmount: FC<IFormUnderlinedAmountProps> = ({
  amount,
  className,
  isLoading = false,
  ...props
}) => {
  if (isLoading) return <Skeleton className="!ml-2" height={16} width={80} />;

  if (amount == 0) return <>0</>;

  if (!amount) {
    return <>-</>;
  }

  return (
    <FormUnderlinedText value={amount} {...props} className={className}>
      {numberFormat(amount)}
    </FormUnderlinedText>
  );
};

export default FormUnderlinedAmount;
